import React, { useState } from "react";
import { motion } from "framer-motion";
import { slideIn } from "../utils/motion";
import fairplazaImg from "../assets/3.jpg";

import { SectionWrapper } from "../hoc";

const FairPlaza = () => {
  const [isImageEnlarged, setIsImageEnlarged] = useState(false);

  const handleImageClick = () => {
    setIsImageEnlarged(!isImageEnlarged);
  };

  const handleClose = () => {
    setIsImageEnlarged(false);
  };

  const handleScrollClose = (event) => {
    if (event.deltaY !== 0) {
      setIsImageEnlarged(false);
    }
  };

  return (
    <section className="px-4 sm:px-8 md:px-16 lg:px-24 py-12 font-poppins">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 items-center">
        {/* Image with hover pop-out effect */}
        <motion.div
          className="flex justify-center"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <img
            src={fairplazaImg}
            alt="Ramro Outlet at Fair Plaza"
            className="rounded-2xl shadow-lg w-full max-w-3xl object-cover cursor-pointer"
            onClick={handleImageClick}
          />
        </motion.div>

        {/* Text content */}
        <div className="flex flex-col justify-center">
          <motion.div variants={slideIn()}>
            <h3 className="text-3xl font-bold text-white mb-4">Onze B2B Outlet</h3>
            <p className="text-secondary leading-[30px] max-w-xl">
              Ramro Imports heeft een fysieke outlet in de <strong>Fair Plaza</strong>, dé B2B fairtrade groothandel in Nederland.
              Vanuit deze locatie bieden wij onze eerlijke producten aan aan winkeliers en zakelijke klanten.
              <br /><br />
              Als officieel erkende <strong>Fair Trade</strong> organisatie zijn wij trots om onderdeel te zijn van dit platform.
              <br /><br />
              Bekijk onze outlet via de officiële Fair Plaza site:{" "}
              <a
                href="https://www.fairplaza.nl/mavanta/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-400"
              >
                www.fairplaza.nl/mavanta
              </a>
            </p>

           
          </motion.div>
        </div>
      </div>

      {isImageEnlarged && (
  <div
    className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 px-4"
    onWheel={handleScrollClose} // desktop scroll close
    onTouchMove={handleScrollClose} // mobile scroll close
  >
    <div className="relative max-w-full max-h-screen overflow-auto">
      <motion.img
        src={fairplazaImg}
        alt="Enlarged Ramro Outlet"
        className="rounded-2xl w-full max-w-[90vw] max-h-[80vh] object-contain mx-auto"
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300 }}
      />
      <button
        onClick={handleClose}
        className="absolute top-2 right-2 text-white text-sm sm:text-base font-bold bg-black bg-opacity-70 px-3 py-1 sm:px-4 sm:py-2 rounded-full hover:bg-opacity-90 transition"
      >
        ✕
      </button>
      <div className="absolute bottom-2 right-2 text-white text-xs sm:text-sm bg-black bg-opacity-60 px-2 py-1 rounded-md">
        Tik of scroll om te sluiten
      </div>
    </div>
  </div>
)}

    </section>
  );
};

export default SectionWrapper(FairPlaza, "fairplaza");
